
export default class FiltroConsultarCliente{
    constructor () {
        this.Cnpj = undefined;
        this.Codigo = undefined;
        this.RazaoSocial = undefined;
        this.NomeReduzido = undefined;
        this.SiglaEstado = undefined;
        this.CidadeId = undefined;
        this.DataCadastroInicio = undefined;
        this.DataCadastroFim = undefined;
        this.Situacao = undefined;
        this.Estado = undefined;
        this.Segmento = undefined;
        this.UnidadeId = undefined;
        this.PerfilMaterial = undefined;
        this.PotencialCliente = undefined;
        this.RepresentanteId = undefined;
        this.DadosBaseCNPJ = true;
        this.DadosClienteAgrupador = false;
    }
}